import React from 'react';

export default function HorizontalList({
  items = [],
  even = false,
  plain = false,
  navClassName = "bg-[#E8F2F4]",
  darkNav = false,
}) {
  const handleClick = (targetId) => {
    if (!targetId) return;
    const el = document.getElementById(targetId);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  if (!items.length) return null;

  const buttonClass = plain && even
    ? darkNav
      ? 'w-full text-center text-white font-semibold text-sm sm:text-base py-2 sm:py-3 hover:text-white/80 hover:underline underline-offset-4 transition sm:flex-1 sm:min-w-0 bg-transparent border-0 cursor-pointer'
      : 'w-full text-center text-[#0054c9] font-semibold text-sm sm:text-base py-2 sm:py-3 hover:text-[#123a72] hover:underline underline-offset-4 transition sm:flex-1 sm:min-w-0 bg-transparent border-0 cursor-pointer'
    : even
      ? darkNav
        ? 'w-full text-center text-white font-semibold text-sm sm:text-base px-2 sm:px-4 py-2.5 sm:py-3 rounded-full border-2 border-white/40 bg-transparent hover:bg-white/10 hover:border-white transition sm:flex-1 sm:min-w-0'
        : 'w-full text-center text-[#0054c9] font-semibold text-sm sm:text-base px-2 sm:px-4 py-2.5 sm:py-3 rounded-full border-2 border-[#0054c9] bg-white hover:bg-[#0054c9] hover:text-white transition sm:flex-1 sm:min-w-0'
      : darkNav
        ? 'text-center text-white font-semibold text-sm sm:text-base underline decoration-2 decoration-white underline-offset-4 sm:no-underline sm:decoration-0 sm:px-5 sm:py-2 sm:rounded-full sm:border-2 sm:border-white/40 sm:bg-transparent sm:hover:bg-white/10 sm:hover:text-white/80 transition'
        : 'text-center text-[#0054c9] font-semibold text-sm sm:text-base underline decoration-2 decoration-[#0054c9] underline-offset-4 sm:no-underline sm:decoration-0 sm:px-5 sm:py-2 sm:rounded-full sm:border-2 sm:border-[#0054c9] sm:bg-white sm:hover:bg-[#0054c9] sm:hover:text-white transition';

  return (
    <nav className={`w-full ${navClassName}`}>
      <div
        className={
          even
            ? 'w-full px-4 sm:px-6 lg:px-8 py-4 sm:py-5'
            : 'max-w-6xl mx-auto px-6 sm:px-8 lg:px-16 py-6'
        }
      >
        <div
          className={
            even
              ? 'grid grid-cols-2 sm:flex sm:w-full gap-2 sm:gap-3'
              : 'grid grid-cols-2 gap-4 sm:flex sm:flex-wrap sm:justify-center sm:items-center sm:gap-4'
          }
        >
          {items.map((item, i) => {
            const label = typeof item === 'string' ? item : item.label;
            const targetId = typeof item === 'object' ? item.targetId : null;

            return (
              <button
                key={`${label}-${i}`}
                type="button"
                onClick={() => handleClick(targetId)}
                className={buttonClass}
              >
                {label}
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
